import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    flex: 1,

    padding: 0,
    height: "100%",
  },

  contentWrapper: {
    height: "100%",
    overflowY: "auto",
    ...theme.scrollbarStyles,
    display: "flex",
    flexDirection: "column",
    // entrada suave ao abrir cada página
    animation: "iaSubir .35s ease backwards",
    // A PAGINA inteira rola (banner/titulo sobem junto), nao so a caixa de
    // baixo. Os filhos diretos crescem ate o tamanho do conteudo em vez de
    // virar uma area de rolagem propria.
    "& > *": {
      flexShrink: "0 !important",
      flexBasis: "auto !important",
      overflowY: "visible !important",
    },
  },
}));

const MainContainer = ({ children, onScroll }) => {
  const classes = useStyles();

  return (
    <Container className={classes.mainContainer} maxWidth={false}>
      <div className={classes.contentWrapper} onScroll={onScroll}>
        {children}
      </div>
    </Container>
  );
};

export default MainContainer;
